import React from 'react'
import { DeadFish } from '@tunasong/icons'
import { AlertError, Typography } from '@tunasong/ui-lib'
import styles from './error-general.module.css'

export interface ErrorProps {
  error?: unknown
}

export const ErrorGeneral = ({ error }: ErrorProps) => (
  <div className={styles.container}>
    <DeadFish className={styles.icon} />
    <Typography variant="h3" className={styles.heading}>
      A dead Tuna is a sad Tuna.
    </Typography>

    <AlertError error={error} />
  </div>
)
